import React, { useState } from "react";
import { Link } from "react-router-dom";
import axios from "axios";
import "bootstrap/dist/css/bootstrap.min.css";
import "../css/global.css";

const ForgotPassword = () => {
  const [email, setEmail] = useState("");
  const [otp, setOtp] = useState("");
  const [newPassword, setNewPassword] = useState("");
  const [message, setMessage] = useState("");
  const [error, setError] = useState("");
  const [step, setStep] = useState(1); // Step 1: Enter email, Step 2: Enter OTP & New Password

  const handleSendOtp = async (e) => {
    e.preventDefault();
    setMessage("");
    setError("");

    if (!email) {
      setError("Please enter your email!");
      return;
    }

    try {
      const response = await axios.post("https://api.irfanelectricals.com/forgot-password/send-otp", { email });
      setMessage(response.data.message);
      setStep(2); // Move to the OTP verification step
    } catch (err) {
      setError(err.response?.data?.message || "Failed to send OTP. Try again.");
    }
  };

  const handleVerifyOtp = async (e) => {
    e.preventDefault();
    setMessage("");
    setError("");

    if (!otp || !newPassword) {
      setError("Please enter OTP and new password!");
      return;
    }

    try {
      const response = await axios.post("https://api.irfanelectricals.com/forgot-password/verify-otp", {
        email,
        otp,
        newPassword,
      });

      setMessage(response.data.message);
      setStep(3); // Password reset successful
    } catch (err) {
      setError(err.response?.data?.message || "Invalid OTP. Try again.");
    }
  };

  return (
    <div className="forgot-password-container d-flex align-items-center justify-content-center min-vh-100 bg-light">
      <div className="card shadow-lg p-4 rounded" style={{ maxWidth: "400px", width: "100%" }}>
        <div className="text-center">
          <h2 className="fw-bold text-primary">Irfan Electricals</h2>
          <p className="text-muted">{step === 1 ? "Reset Your Password" : "Enter OTP to reset password"}</p>
        </div>

        {error && <div className="alert alert-danger p-2">{error}</div>}
        {message && <div className="alert alert-success p-2">{message}</div>}

        {step === 1 && (
          <form onSubmit={handleSendOtp}>
            <div className="mb-3">
              <label className="form-label fw-semibold">Email Address</label>
              <input
                type="email"
                className="form-control"
                placeholder="Enter your email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
              />
            </div>
            <button type="submit" className="btn btn-primary w-100 fw-bold">Send OTP</button>
          </form>
        )}

        {step === 2 && (
          <form onSubmit={handleVerifyOtp}>
            <div className="mb-3">
              <label className="form-label fw-semibold">Enter OTP</label>
              <input
                type="text"
                className="form-control"
                placeholder="Enter OTP"
                value={otp}
                onChange={(e) => setOtp(e.target.value)}
              />
            </div>

            <div className="mb-3">
              <label className="form-label fw-semibold">New Password</label>
              <input
                type="password"
                className="form-control"
                placeholder="Enter new password"
                value={newPassword}
                onChange={(e) => setNewPassword(e.target.value)}
              />
            </div>

            <button type="submit" className="btn btn-success w-100 fw-bold">Reset Password</button>
          </form>
        )}

        {step === 3 && (
          <div className="text-center">
            <p className="text-success fw-bold">Password Reset Successfully!</p>
            <Link to="/login" className="btn btn-primary w-100 fw-bold">Back to Login</Link>
          </div>
        )}

        <p className="mt-3 text-center">
          <Link to="/login" className="text-primary">Back to Login</Link>
        </p>
      </div>
    </div>
  );
};

export default ForgotPassword;
